import { Form, FormProps, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

interface ServiceOrderAdminDataProps {
  formProps?: FormProps;
}

const ServiceOrderAdminData = (props: ServiceOrderAdminDataProps) => {
  const { t } = useTranslation();
  const { formProps } = props;
  // Mapea el valor persistido (string separado por comas) a valores editables en UI.
  const watchedTechnicianPay = Form.useWatch('technician_pay', formProps?.form);
  const watchedCustomerInvoice = Form.useWatch('customer_invoice', formProps?.form);
  const technicianPay = watchedTechnicianPay ?? formProps?.form?.getFieldValue('technician_pay');
  const customerInvoice =
    watchedCustomerInvoice ?? formProps?.form?.getFieldValue('customer_invoice');
  const billingNumbersToList = (value?: string | string[]) => {
    if (!value) return [];
    if (Array.isArray(value)) return value.filter(v => v && v.trim().length > 0);

    return value
      .split(',')
      .map(v => v.trim())
      .filter(Boolean);
  };

  // Convierte el listado editable del input a un string separado por comas para guardar en backend.
  const billingNumbersToString = (value?: string[]) =>
    (value ?? [])
      .map(v => v.trim())
      .filter(Boolean)
      .join(',');

  return (
    <div className="ServiceOrderFormRow">
      {technicianPay ? (
        <Form.Item
          label={t('Números de factura del técnico')}
          name={'billing_numbers'}
          rules={[
            {
              required: true,
              message: t('Los {{field}} son obligatorios', {
                field: t('números de factura del técnico'),
              }),
            },
          ]}
          getValueProps={value => ({
            value: billingNumbersToList(value),
          })}
          getValueFromEvent={(value: string[]) => billingNumbersToString(value)}
        >
          <Select
            mode="tags"
            tokenSeparators={[',']}
            placeholder={t('Ingrese uno o más números de factura')}
          />
        </Form.Item>
      ) : (
        <Form.Item label={t('Números de factura del técnico')}>
          <Typography.Text type="secondary">{t('No hay pago al técnico')}</Typography.Text>
        </Form.Item>
      )}
      <Form.Item
        label={t('Números de factura del cliente')}
        name={'customer_billing_numbers'}
        rules={[
          {
            required: Boolean(customerInvoice),
            message: t('Los {{field}} son obligatorios', {
              field: t('números de factura del cliente'),
            }),
          },
        ]}
        getValueProps={value => ({
          value: billingNumbersToList(value),
        })}
        getValueFromEvent={(value: string[]) => billingNumbersToString(value)}
      >
        <Select
          mode="tags"
          tokenSeparators={[',']}
          placeholder={t('Ingrese uno o más números de factura')}
        />
      </Form.Item>
    </div>
  );
};

export default ServiceOrderAdminData;
